// Live chat SupportBoxu — slovenské dvojče locale/cs/supportChat.js (SK chat
// nemá, manifest `chat` je null; texty drží tvar kvôli buildu).
export default {
  open: 'Otvoriť chat',
  unread: 'Otvoriť chat, máte novú odpoveď',
  loading: 'Načítavame chat',
  failed: (email) => 'Chat sa teraz nepodarilo otvoriť. Napíšte nám na ' + email + '.',
  cta: 'Napísať do chatu',
  ask: 'Opýtať sa v chate',
  buyboxLead: 'Máte otázku?',
  buyboxCta: 'Napíšte nám do chatu',
  productTopic: (name) => 'Otázka k produktu ' + name + ': ',
};
